import { useHistory } from '@shared/core';
import { useRouterHelper } from '@shared/core/router.helper';
import { useQueryParamHelper } from '@shared/core/queryString';
import { routePaths } from '@apps/acquisitionFunnels/createWedding/route.paths';

type NavigableRoute = 'signIn' | 'forgotPassword' | 'createAccount';

export const useCreateWeddingNavigation = () => {
  const history = useHistory();
  const queryParamHelper = useQueryParamHelper();
  const routeHelpers = useRouterHelper();

  const navigateTo = (routeName: NavigableRoute, state?: Record<string, unknown>) => {
    const path = queryParamHelper.buildRedirectPath(routeHelpers.buildPath(routePaths[routeName].path));
    history.push(path, state);
  };

  return { navigateTo };
};
